<template>
  <div class="reauth-page">
    <q-card class="reauth-card">
      <q-card-section class="text-center">
        <img src="https://uniqin-email-images.s3.us-west-2.amazonaws.com/logos-uniqin/uniqin_new_logo.jpg"
             style="width: 100px; margin-bottom: 20px;" />
        <h4>Reconnect Your Amazon Account</h4>
      </q-card-section>

      <!-- Loading -->
      <q-card-section v-if="loading">
        <div class="text-center">
          <q-spinner color="primary" size="50px" />
          <p>Validating your request...</p>
        </div>
      </q-card-section>

      <!-- Error -->
      <q-card-section v-else-if="error">
        <div class="text-center">
          <q-icon name="error" color="negative" size="50px" />
          <h5>{{ errorMessage }}</h5>
          <q-btn label="Contact Support" color="primary" @click="contactSupport" />
        </div>
      </q-card-section>

      <!-- Main Content -->
      <q-card-section v-else-if="tokenValidated && !authComplete">
        <div class="text-center q-mb-md">
          <p><strong>{{ sellerName }}</strong></p>
          <p class="text-grey">{{ sellerEmail }}</p>
        </div>

        <q-banner class="bg-warning text-white q-mb-md">
          Your Amazon connection needs to be renewed for security.
        </q-banner>

        <div class="q-mb-lg">
          <h6>Click below to reconnect:</h6>
          <q-btn
            label="Reconnect Amazon SP-API"
            color="primary"
            class="full-width q-mb-sm"
            @click="reconnectSpApi"
            :loading="connecting"
          />
        </div>
      </q-card-section>

      <!-- Success -->
      <q-card-section v-else-if="authComplete" class="text-center">
        <q-icon name="check_circle" color="positive" size="80px" />
        <h5>Successfully Reconnected!</h5>
        <q-btn label="Go to Dashboard" color="primary" @click="goToDashboard" />
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
export default {
  name: "SellerReAuth",
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: "",
      tokenValidated: false,
      authComplete: false,
      token: "",
      sellerId: "",
      topLevelOrgId: "",
      sellerEmail: "",
      sellerName: "Seller",
      connecting: false,
      apiUrl: this.$store.state.API_URL[process.env.VUE_APP_ENV],
    };
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get("token");

    if (!this.token) {
      this.error = true;
      this.errorMessage = "Invalid re-authorization link";
      this.loading = false;
      return;
    }

    await this.validateToken();
  },
  methods: {
    async validateToken() {
      try {
        const response = await this.$http.post(
          `${this.apiUrl}/seller-reauth/validate-token`,
          { token: this.token }
        );

        if (response.data.success) {
          this.tokenValidated = true;
          this.sellerId = response.data.seller_id;
          this.topLevelOrgId = response.data.top_level_orgid;
          this.sellerEmail = response.data.email;
          this.sellerName = `Organization ${this.topLevelOrgId}`;
        } else {
          this.error = true;
          this.errorMessage = "This link has expired or been used. Please request a new one.";
        }
      } catch (error) {
        this.error = true;
        this.errorMessage = "Unable to validate link. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    async reconnectSpApi() {
      try {
        this.connecting = true;
        const response = await this.$http.post(`${this.apiUrl}/repricer/get_seller_api_url`);

        localStorage.setItem("seller_id", this.sellerId);
        localStorage.setItem("top_level_orgid", this.topLevelOrgId);
        localStorage.setItem("region", "in");
        localStorage.setItem("ac_conn_status", "true");

        window.location.href = response.data;
      } catch (error) {
        this.$q.notify({
          message: "Failed to start authorization",
          color: "negative"
        });
        this.connecting = false;
      }
    },

    contactSupport() {
      window.location.href = "mailto:support@uniqin.ai";
    },

    goToDashboard() {
      this.$router.push("/home");
    }
  }
};
</script>

<style scoped>
.reauth-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.reauth-card {
  max-width: 500px;
  width: 100%;
}
</style>
